import isGiftSetStrVariantUtil from 'modules/variant/utils/is-gift-set-str'

export default function isGiftSetVariantUtil (variant) {
  if (!variant) {
    return false
  }

  return isGiftSetStrVariantUtil(variant.sku)
}
